module.exports = __webpack_public_path__ + "img/csv-export.ca28747e.svg";